import { v4 as uuid } from "uuid";
import store from '../store/index';
import i18n from '@/i18n/i18n'


export function triggleActionPanel(list, device) {
  const actionList = [];

  if (list.length === 0) return actionList;

  const processOperationType = (action, operationType) => {
    const insertAction = window.deepCloneNew ? window.deepCloneNew(action) : action;
  
    if (operationType.Value === 4) {
      insertAction.ValueType = 'UIControl_ChooseRange';
      insertAction.DefaultValue = [action.Min, action.Max];
    }
    if (operationType.Value === 8) {
      insertAction.ValueType = 'UIControl_Slider';
      insertAction.DefaultValue = [action.Min, action.Max];
    }

    actionList.push({
      ...insertAction,
      uuid: uuid(),
      OperationName: operationType.Name,
      OperationValue: operationType.Value
    });
  };

  list.forEach(action => {
    if (action.ValueType === 'UIControl_ChooseRange') {
      action.DefaultValue = [action.Min, action.Max];
    } else if (action.ValueType === 'UIControl_MultipleDropdownList') {
      // ????? 很奇怪
      // action.DefaultValue = action.DefaultValue.split(',');
    } else {
      action.DefaultValue = Number(action.DefaultValue);
    }

    // action.ischeck = false;
    action.OperationType.forEach(operationType => {
      processOperationType(action, operationType);
    });
  });

  return actionList;
  //  
  // if (!!device && !this.modifyItem) {
  //   const isMatchingDevice = device.vDeviceId === this.modifyItem.VDeviceId;
  //   const hasModifyItemTriggle = !!this.modifyItem.triggle;

  //   if (isMatchingDevice && hasModifyItemTriggle) {
  //     this.cur = this.deviceTriggerFilter(actionList, this.modifyItem.triggle, false, true, this.deviceOption);
  //     this.checkRadio(actionList[this.cur] || null, this.cur);
  //   }
  // }
}

export function sortActionList(list) {
  const actionList = list.slice();

  actionList.sort(function (pre, next) {
    if (pre.KeyID !== next.KeyID) return pre.KeyID - next.KeyID;
  
    if (pre.ExtraKeyId !== next.ExtraKeyId) return pre.ExtraKeyId - next.ExtraKeyId;
  
    if (pre.DefaultValue < next.DefaultValue) return 1;
    
    if (pre.DefaultValue > next.DefaultValue) return -1;

    return 0;
  });

  return actionList;
}

export function deviceTriggerFilter(list, triggle, isModifyItem, isCheck, deviceOption) {
  
}


export class ActionVo {
  constructor(params) {
    this.init(params); 
  }

  static isConflictActionSingle(type, currentMsgTypes, actionMsgType, checkedActionList) {
    let passMsg = '';
    let result = true;

    const MutualExclusion = store.state.staticConfig?.MutualExclusion[type] || [];

    for (let i = 0; i < MutualExclusion.length; i++) {
      const currentList = MutualExclusion[i];

      const existActionMsg = currentList.find(item => item.Data.includes(actionMsgType));

      if (existActionMsg) {
        const conflict = currentList.filter(list => existActionMsg !== list);
        
        currentMsgTypes.forEach(MsgType => {
          const conflictAction = conflict.find(item => item.Data.includes(MsgType));
          if (conflictAction) {
            result = false;
            passMsg = `【${conflictAction.Name}】【${existActionMsg.Name}】 ${i18n.t('iftttset.noSimultaneously')}`
          }
        });
      }

      if (!result) break;
    };

    return {
      result,
      passMsg
    }
  }

  /** 互斥配置 Data 项与设备 MsgType 对齐（配置多为 orderType，设备多为短 MsgType） */
  static msgTypeMatchesExclusion(msgType, dataItem) {
    if (!msgType || !dataItem) return false;
    if (dataItem === msgType) return true;
    const dataBase = String(dataItem).replace(/_\d+$/, '');
    return String(dataItem).includes(msgType) || String(msgType).includes(dataBase);
  }

  static isInExclusionData(msgType, dataArray) {
    if (!msgType || !Array.isArray(dataArray)) return false;
    return dataArray.some((d) => ActionVo.msgTypeMatchesExclusion(msgType, d));
  }

  static isConflictAction(type, currentMsgType, checkedActionList) {
    debugger
    let passMsg = '';
    let result = true;

    const MutualExclusion = store.state.staticConfig?.MutualExclusion[type] || [];
    const enabledActions = (checkedActionList || []).filter((action) => action.ischeck === true);

    for (let i = 0; i < MutualExclusion.length; i++) {
      const currentList = MutualExclusion[i];

      const existActionMsg = currentList.find((item) =>
        ActionVo.isInExclusionData(currentMsgType, item.Data)
      );

      if (existActionMsg) {
        const conflict = currentList.filter((list) => existActionMsg !== list);

        enabledActions.forEach((action) => {
          if (action.MsgType === currentMsgType) return;
          const conflictAction = conflict.find((item) =>
            ActionVo.isInExclusionData(action.MsgType, item.Data)
          );

          if (conflictAction) {
            result = false;
            passMsg = `【${conflictAction.Name}】【${existActionMsg.Name}】 ${i18n.t('iftttset.noSimultaneously')}`;
          }
        });
      }

      if (!result) break;
    }

    const DIM_MSG_TYPES = ['0x03DA00000x03840000', '0x03', '0x03840000', '0x03DA0000', '0x03D80000'];
    const CCT_MSG_TYPES = ['0x03880000', '0x04'];

    if (DIM_MSG_TYPES.includes(currentMsgType)) {
      if (enabledActions.find((item) => item.MsgType !== currentMsgType && DIM_MSG_TYPES.includes(item.MsgType))) {
        result = false;
        passMsg = `【${i18n.t('sceneCard.light')}】【${i18n.t('sceneCard.dim')}】${i18n.t('iftttset.noSimultaneously')}`;
      }
    }

    if (CCT_MSG_TYPES.includes(currentMsgType)) {
      if (enabledActions.find((item) => item.MsgType !== currentMsgType && CCT_MSG_TYPES.includes(item.MsgType))) {
        result = false;
        passMsg = `【${i18n.t('sceneCard.colorWarm')}】【${i18n.t('sceneCard.cct')}】${i18n.t('iftttset.noSimultaneously')}`;
      }
    }

    return {
      result,
      passMsg
    };
  }

  static isLight(action) {
    return action.Type && action.Type.startsWith('0x03');
  }

  static isPLaySpeed(action) {
    return action.Type && action.Type.startsWith('0x1E1F');
  }

  static isColorPanel(action) {
    return action.ValueType === 'UIControl_ColorPanel';
  }

  init(params) {
    Object.entries(params).forEach(([key, value]) => {
      this[key] = value;
    });

    // console.log('this', this, this.Type);
    
    if (ActionVo.isLight(this)) {
      const { DefaultValue, Min, Max } = transLightValueToProp(this);

      this.DefaultValue = DefaultValue;
      this.Min = Min;
      this.Max = Max;
      // this.DefaultValue_ = DefaultValue_;
      // this.Min_ = Min_;
      // this.Max_ = Max_;
      this.Value = DefaultValue;
    } 
    
    if (ActionVo.isColorPanel(this)) {
      this.DefaultValue_ =  Number(this.Value);
      const value = `#${this.DefaultValue_.toString(16)}`;
      this.DefaultValue = value;
      this.Value = value;
    }
    this.Name = params.Name 
    this.Name_ = params.Name
    this.oldMax = params.Max //保留原始最大值
    this.oldMin = params.Min //保留原始最小值
  }

  getSubmitData() {
    let Value = this.DefaultValue;

    if (ActionVo.isLight(this)) {
      Value = transLightPropToValue(this);
    }

    // if (ActionVo.isPLaySpeed(this)) {
    //   Value = transPeedPropToValue(this);
    // }
    
    if (typeof this.DefaultValue === 'string' && this.DefaultValue.startsWith('#')) {
      Value = parseInt('0x' + this.DefaultValue.substr(1))
    }
    
    return {
      KeyId: this.KeyId,
      Value,
    };
  }

  static getSubmitData(action) {
    let Value = action.DefaultValue;

    if (ActionVo.isLight(action)) {
      Value = transLightPropToValue(action);
    }

    // if (ActionVo.isPLaySpeed(action)) {
    //   Value = transPeedPropToValue(action);
    // }
    
    if (typeof action.DefaultValue === 'string' && action.DefaultValue.startsWith('#')) {
      Value = parseInt('0x' + action.DefaultValue.substr(1))
    }

    return {
      KeyId: action.KeyId,
      Value,
    };
  }
}

export function transLightToProp(value, max = 255) {
  const v = Number(value);
  const prop = v === 1 ? 1 : Math.round(v * 100 / max); 

  return Number.isNaN(prop) ? 0 : prop;
}

/**
 * 将亮度固定值转为百分比
 */
export function transLightValueToProp(params) {
  const DefaultValue = Number(params.DefaultValue);
  const Min = Number(params.Min);
  const Max = Number(params.Max);
  
  const prop = transLightToProp(DefaultValue, Max); 
  const MinProp = transLightToProp(Min, Max); 
  console.log('将亮度固定值转为百分比', prop, MinProp, DefaultValue)
  return {
    DefaultValue: prop,
    Min: MinProp,
    Max: 100,
    // DefaultValue_: DefaultValue,
    // Min_: Min,
    // Max_: Max
  }
}

/**
 * 将亮度百分比转为固定值
 */
export function transLightToValue(value, max = 255) {
  // 特殊值
  const light = value === 1 ? 2 : Math.round(value * max / 100);

  return light;
}

/**
 * 将亮度百分比转为固定值
 */
export function transLightPropToValue(action) {
  const max = Number.isInteger(action.Max_) ? action.Max_ : 255;

  return transLightToValue(action.DefaultValue, max);
}


//将倍速乘以10下发
export function transPeedPropToValue(action) {
  // 0.1-2
  const speed = action.DefaultValue* 10;

  return speed;
}